.user-avatar {
    display: block;
    flex: 0 0 auto;
    width: var(--user-avatar-size, 30px);
    height: var(--user-avatar-size, 30px);
    border-radius: 50%;
    object-fit: cover;
}

.user-identity {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
    vertical-align: middle;
    color: inherit;
    line-height: 1.4;
    text-decoration: none;

    .user-avatar {
        border-radius: 50%;
    }
    .user-identity-info {
        display: flex;
        flex-direction: column;
        min-width: 0;
        gap: 2px;
    }
    .user-identity-name {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .user-identity-secondary {
        color: var(--ui-text-secondary);
        font-size: 12px;
        font-weight: 400;
    }
    &.user-identity--inline .user-identity-info {
        flex-direction: row;
        align-items: baseline;
        gap: 4px;
    }
    &.user-identity--inline .user-identity-secondary {
        flex-shrink: 0;
        font-size: inherit;
        white-space: nowrap;
    }
}

a.user-identity:hover {
    color: var(--ui-link-hover);
    text-decoration: none;
}
